var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 93.126,
    height: 22.356,
    viewBox: "0 0 93.126 22.356",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-946.781 -4149.682)"
  }, /*#__PURE__*/React.createElement("line", {
    y1: 15.938,
    x2: 43.354,
    transform: "translate(949.99 4152.891)",
    fill: "none",
    stroke: "#777776",
    strokeLinecap: "round",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 43.354,
    y1: 15.938,
    transform: "translate(993.344 4152.891)",
    fill: "none",
    stroke: "#777776",
    strokeLinecap: "round",
    strokeWidth: 5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUp);
export default __webpack_public_path__ + "static/media/ArrowUp.80c172e1fcf611af190ad93804ff79b5.svg";
export { ForwardRef as ReactComponent };